<template>
  <div></div>
</template>

<script>
  import server from '../api/server.js'
  export default {
    name: 'new_window',
    created () {
      // console.log('new_window', this)
      server.openApiGet(this.$router.query.url, () => {}, () => {})
    }
  }
</script>


// WEBPACK FOOTER //
// NewWindow.vue?257261f7